import React from 'react';

type LegalSectionProps = {
  id: string;
  title: string;
  number?: string;
  children: React.ReactNode;
  className?: string;
};

const LegalSection: React.FC<LegalSectionProps> = ({
  id,
  title,
  number,
  children,
  className = '',
}) => (
  <section id={id} className={`ats-legal-section ${className}`.trim()}>
    <div className="ats-legal-section__heading">
      {number ? <span aria-hidden="true">{number}</span> : null}
      <h2>{title}</h2>
    </div>
    <div className="ats-legal-section__body">{children}</div>
  </section>
);

export default LegalSection;
